import appSettingStore from '../store/appSetting';
import parsePhoneNumber from 'libphonenumber-js';

export class StringHelper {
    constructor() { }

    static phoneNumberFormat(phone, isHalfShow = false) {
        const GERMANY_COUNTRY_CODE = 'DE';
        const phoneString = `${phone}`;
        const isInGermany = appSettingStore.state.countryCode === GERMANY_COUNTRY_CODE;
        if(isInGermany) {
          const phoneNumber = parsePhoneNumber(phoneString, GERMANY_COUNTRY_CODE);
          if(!phoneNumber || !phoneNumber.isValid()) return phone;
          // console.log(phoneNumber.formatNational()) // 05845 462164
          // console.log(phoneNumber.formatInternational()) //+49 5845 462164
          return phoneNumber.formatInternational()
        }

        //Filter only numbers
        let number = ('' + phone).replace(/[^\d]/g, '');
        if (number.length > 10) {
            number = number.substr(number.length - 10);
        }
        if (number.length == 10) {
            if (isHalfShow) {
                number = number.replace(/(\d{3})(\d{3})(\d{4})/, "(***) ***-$3");
            } else {
                number = number.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
            }
            return number;
        }
        return '';
    }

    static phoneToString(phone) {
        let number = ('' + phone).replace(/[^\d]/g, '');
        return number;
    }

    static staffCodeFormat(code) {
        let num = parseInt(code);
        if (num < 10) {
            return "00" + num;
        }
        if (num >= 10 && num < 100) {
            return "0" + num;
        }
        return "" + num;
    }

    static changeFormatAvatar(str) {
        let words = [];
        if (str != undefined) {
            words = str.trim().split(' ');
        }
        for (let i = 0; i < words.length; i++) {
            if (words[i].length < 6) {
                words[i] += '.....';
            }
        }
        if (words.length > 3) {
            let temp = [];
            for (let i = 0; i < words.length; i++) {
                if (i == 3) {
                    return temp.join(' ');
                }
                temp.push(words[i]);
            }
        }
        return words.join(' ');
    }

    static validateEmail(email) {
        // eslint-disable-next-line
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    static isNumber(charCode) {
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    static isLetter(charCode) {
        if (charCode < 48 || (charCode > 57 && charCode < 65) || (charCode > 90 && charCode < 97) || charCode > 122) {
            return false;
        }
        return true;
    }

    static isSpecialCharacter(charCode) {
        if (charCode != 45 && charCode != 46 && charCode != 95 && charCode != 64) {
            return false;
        }
        return true;
    }

    static isSpecialInLast(str) {
        if (str && str.length != 0) {
            let last_char = str.charAt(str.length - 1);
            if (last_char == '-' || last_char == '.' || last_char == '_' || last_char == '@') {
                return true;
            }
        }
        return false;
    }

    static validateEmailChar(evt, email) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        // var regex = new RegExp("a-zA-Z0-9.@");

        // if((charCode < 45 || (charCode > 57 && charCode < 64) || (charCode > 90 && charCode < 95) || (charCode > 95 && charCode < 97) || charCode > 122 || charCode == 47)
        //     || (charCode == 64 && email.indexOf("@") != -1) || (charCode == 46 && email.indexOf("@")!= -1 && email.indexOf("@") < email.lastIndexOf("."))
        //     || ((email.charAt(email.length - 1) == 45 || email.charAt(email.length - 1) == 46 || email.charAt(email.length - 1) == 95))) {
        //    evt.preventDefault();
        // } else {
        //   return true;
        // }
        var number = this.isNumber(charCode);
        var letter = this.isLetter(charCode);
        var special_char = this.isSpecialCharacter(charCode);
        if (email == null) {
            email = '';
        }
        if ((!number && !letter && !special_char) || (charCode == 64 && email.indexOf('@') != -1)
            || (special_char && email.indexOf("@") != -1 && email.indexOf("@") < email.lastIndexOf("."))
            || (this.isSpecialInLast(email) && special_char) || (email == '' && special_char)) {
            evt.preventDefault();
        } else {
            return true;
        }
    }

    static getErrorName(str, field) {
        if (str && str != '' && str.includes(field)) {
            if (str.includes('required')) {
                return 'The name field is required';
            } else if (str.includes('format')) {
                return 'The name must not include special characters';
            }
            // return str.replace(field, 'name');
        }
        return str;
    }

    static getErrorPhone(str, field) {
        if (str && str != '' && str.includes(field)) {
            return str.replace(field, 'phone');
        }
        return str;
    }
}
